
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Zuerst umgekehrt: Ungesund ist ein Pyjama mit Sicherheit nicht, zumindest, solange es uns beim Einschlafen nicht stört. Nackt schlafen könnte sich aber positiv auf das Beziehungsleben auswirken. Denn je mehr Hautkontakt wir mit unserem Partner haben, desto mehr des Kuschelhormons Oxytocin scheidet der Körper aus. `}<br /><br />{`
Doch nicht nur in der Partnerschaft hat das Nacktschlafen Vorteile: Man soll hüllenlos tatsächlich auch länger jung bleiben. Zu diesem Ergebnis kam eine Studie aus dem Jahr 2014 im Fachblatt «Sleep». Demnach wird durch die Vermeidung eines Wärmestaus unter der Bettdecke die Produktion von Melatonin, einem Hormon, das unseren Tag-Nacht-Rhythmus steuert, sowie von Wachstums- und Anti-Aging-Hormonen angeregt. Eine US-Studie, die im «Journal of Diabetes» veröffentlicht wurde, hat zudem herausgefunden, dass kühle `}<Link href='https://www.ncbi.nlm.nih.gov/pubmed/24954193' mdxType="Link">{`Temperaturen im Schlafzimmer`}</Link>{` helfen, mehr Kalorien zu verbrennen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;